import React, {Component} from 'react';
import {t, Trans} from '@lingui/macro';
import WelcomeUser from '../WelcomeUser';
import RaisedButton from '../RaisedButton';

//import classNames from 'classnames';
import s from './Home.css';

class Home extends Component {
  render() {
    const {userName, introText, completeTutorial} = this.props;

    return (
      <div className={s.Home}>
        <header className={s.Header}>
          <section className={s.HeaderRow}>
            <section className={s.TitleContainer}>
              <WelcomeUser userName={userName || 'guest'} />
              <div className={s.Intro}>
                <h2 className={s.Subtitle}>
                  {introText ||
                    t({
                      id: `home.default_intro_text`,
                      message:
                        'Benvenuto nella test room. Qui troverai le prove che ti sono state assegnate.<br />Prima di iniziare guarda il tutorial sul funzionamento.`'
                    })}
                </h2>
                <RaisedButton
                  className={s.StartButton}
                  onClick={() => completeTutorial()}
                >
                  <Trans id="home.button_start_tutorial">
                    Inizia il Tutorial
                  </Trans>
                </RaisedButton>
              </div>
            </section>
          </section>
        </header>
      </div>
    );
  }
}

export default Home;
